module.exports = __webpack_public_path__ + "img/Rhode Island outline.0d87d91c.png";